export enum FilterTypeEnum {
  WorkerAgreementsList = 1,
  WorkersList = 2,
  DeclarationList = 3,
  EmploymentConditionsConfirmationList = 4,
  MandateAgreementWorkedDayList = 5,
  PresencePerDayList = 6,
  PresencePerMonthList = 7,
  HolidayPerMonthList = 8,
  AbsencesPerYearList = 9,
  OrdersList = 10,
  OrdersStartRealizationList = 11,
  LegalizationsList = 12,
  EFoldersList = 100,
  EAbsenceConclusionsList = 101,
  EFoldersDraftList = 102,
  EFoldersUcpList = 103,
  EDocumentsList = 104,
}